
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title ,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Stotra "Srimaddattatraiyaguruve Namah" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Stotra "Srimaddattatraiyaguruve Namah" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'52 Shloki Guru Charitra, Dattatreya Guru Charitra, Dattatreya , Guru Charitra, 52 Shloki Guru Charitra lyrics, 52 Shloki Guru Charitra lyrics marathi, 52 Shloki Guru Charitra lyrics english'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Srimaddattatraiyaguruve Namah, 52 Shloki Guru Charitra, Dattatreya Guru Charitra, Dattatreya worship, Lord Dattatreya prayer, Dattatreya stotra, Guru Parampara, Dattatreya mantra, 52 Shlokas of Guru Charitra, Dattatreya stuti, Shloka chant, ५२ श्लोकी गुरुचरित्र,  52 Shloki Gurucharitra with Lyrics, 52 Shloki Gurucharitra with Lyrics marathi, 52 Shloki Gurucharitra with Lyrics english, ' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/stotra/gurucharitra.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/stotra/gurucharitra.webp'
          },
          ],
        }
      },
    
      components: {
      },
      data() {
        return {
          title: 'Srimaddattatraiyaguruve Namah | 52 Shloki Guru Charitra - श्रीमद्दत्तात्रैयगुरुवे नमः (५२ श्लोकी गुरुचरित्र)',
          langauageMarathi: true
        }
      },
      layout: 'detailsPage-withoutFooter',
      
      jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/stotra/gurucharitra"
        },
        "headline": "Srimaddattatraiyaguruve Namah - श्रीमद्दत्तात्रैयगुरुवे नमः (५२ श्लोकी गुरुचरित्र)",
        "name" : "Srimaddattatraiyaguruve Namah - 52 Shloki Guru Charitra",
        "description": "Explore the full lyrics of stotra 'Srimaddattatraiyaguruve Namah' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/stotra/gurucharitra.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },
  
  
      computed: {
  
      },
      methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
  
    }
  